module.exports = __webpack_public_path__ + "static/quokkas-19b0277611182ac88efd6de2f5ef3297.jpg";